"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _styles = require("../styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var SolidStar = function SolidStar(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#1A1A1A' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/React.createElement(_styles.Svg, {
    width: size,
    height: size,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className, " ").concat(animation)
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.42 7.78C19.3 7.3 18.88 7 18.4 6.88L13.42 6.16L11.2 1.66C10.96 1.24 10.54 0.939999 10.06 0.939999C9.57998 0.939999 9.09998 1.24 8.91998 1.66L6.69998 6.16L1.71998 6.88C1.23998 6.94 0.819976 7.3 0.699976 7.78C0.579976 8.26 0.699976 8.74 0.999976 9.1L4.59998 12.58L3.75998 17.5C3.63998 17.98 3.87998 18.46 4.23998 18.76C4.65998 19.06 5.13998 19.06 5.61998 18.88L10.06 16.54L14.5 18.88C14.68 19 14.92 19 15.1 19C15.4 19 15.64 18.94 15.88 18.76C16.3 18.46 16.48 17.98 16.42 17.5L15.58 12.58L19.18 9.1C19.42 8.74 19.54 8.26 19.42 7.78Z",
    fill: color
  }));
};
var _default = exports["default"] = SolidStar;